module.exports = __webpack_public_path__ + "static/img/baifenzhi.201f4259.png";